var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmoking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Smoking"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.9898 9.65118C14.902 9.73898 14.902 9.87508 14.9898 9.96288C15.0337 10.0068 15.0908 10.0287 15.1435 10.0287C15.1962 10.0287 15.2576 10.0068 15.2971 9.96288C15.341 9.91898 15.7098 9.5063 15.3498 8.42191C15.0864 7.62727 15.2883 7.34191 15.3015 7.32435C15.3805 7.23654 15.3805 7.10483 15.2971 7.02142C15.2093 6.93362 15.0732 6.93362 14.9854 7.02142C14.9415 7.06532 14.5727 7.47801 14.9327 8.5624C15.2093 9.36581 14.9898 9.65118 14.9898 9.65118Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.8205 9.65118C16.7327 9.73898 16.7327 9.87508 16.8205 9.96288C16.8644 10.0068 16.9215 10.0287 16.9742 10.0287C17.0268 10.0287 17.0883 10.0068 17.1278 9.96288C17.1717 9.91898 17.5405 9.5063 17.1805 8.42191C16.9171 7.62727 17.119 7.34191 17.1322 7.32435C17.2112 7.23654 17.2112 7.10483 17.1278 7.02142C17.04 6.93362 16.9039 6.93362 16.8161 7.02142C16.7722 7.06532 16.4034 7.47801 16.7634 8.5624C17.0356 9.36581 16.8205 9.65118 16.8205 9.65118Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.2683 10.9023H15.2927H5.85367C5.73074 10.9023 5.63416 10.9989 5.63416 11.1219V13.0975C5.63416 13.2204 5.73074 13.317 5.85367 13.317H15.2927H17.2683C17.3912 13.317 17.4878 13.2204 17.4878 13.0975V11.1219C17.4878 10.9989 17.3912 10.9023 17.2683 10.9023ZM15.0732 12.878H6.07318V11.3414H15.0732V12.878ZM17.0488 12.878H15.5122V11.3414H17.0488V12.878Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12 3C7.03902 3 3 7.03902 3 12C3 16.961 7.03902 21 12 21C16.961 21 21 16.961 21 12C21 7.03902 16.961 3 12 3ZM12 20.561C7.28049 20.561 3.43902 16.7195 3.43902 12C3.43902 7.28049 7.28049 3.43902 12 3.43902C16.7195 3.43902 20.561 7.28049 20.561 12C20.561 16.7195 16.7195 20.561 12 20.561Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmoking);
export default __webpack_public_path__ + "static/media/Smoking.86a7fa2c74340e8430a87b4296f41648.svg";
export { ForwardRef as ReactComponent };